import {Router} from "./router";
import getModulesNames from "rapid/getModulesNames.helper";
import {AuthModule} from "./auth/auth";
import {LayoutModule} from "./layout/layout";
import ConfigurationsModule from "./configurations/configurations-module";
import DeploymentsModule from "./deployments/deployments-module";
import ClientsModule from "./clients/clients-module";
import BoothsModule from "./booths/booths-module";
import UsersModule from "./users/users-module";
import {addressComponent} from "./common/address/address.component";
import {selectSearchComponent} from "./common/select-search/select-search.component";
import {apiSelectSearchComponent} from "./common/api-select-search/api-select-search.component";
import {htmlPreviewComponent} from "./common/html-preview/html-preview.component";
import {scenePreviewComponent} from "./common/scene-preview/scene-preview.component";
import {startScreenAreaComponent} from "./common/start-screen-area/start-screen-area.component";
import {photoInputComponent} from "./common/photo-input/photo-input.component";
import {phoneMsgComponent} from "./common/phone-msg/phone-msg.component";
import {emailPreviewComponent} from "./common/email-preview/email-preview.component";
import {loaderComponent} from "./common/loader/loader.component";
import {AnalyticsModule} from "./analytics/analytics";
import {MediaModule} from "./media/media";
import {formPreviewComponent} from "./common/forms-preview/form-preview.component.js";
import ChartsModule from "./charts/charts.module";
import {liveViewPreviewComponent} from "./common/live-view-preview/live-view-preview.component";
import {htmlCustomBtnPreviewComponent} from "./common/html-custom-btn-preview/html-custom-btn-preview.component";
import {individualTextOutputPreviewComponent} from "./common/individual-text-output-preview/individual-text-output-preview.component";
import {individualTextScreenPreviewComponent} from "./common/individual-text-screen-preview/individual-text-screen-preview.component";
import {aiHtmlPreviewComponent} from "./common/ai-html-preview/ai-html-preview.component";


export const ComponentsModule = angular
    .module("app.components", getModulesNames([
        AuthModule,
        LayoutModule,
        ConfigurationsModule,
        DeploymentsModule,
        AnalyticsModule,
        ClientsModule,
        BoothsModule,
        UsersModule,
        ChartsModule,
        MediaModule
    ]))
    .config(Router)
    .component("addressForm", addressComponent)
    .component("selectSearch", selectSearchComponent)
    .component("apiSelectSearch", apiSelectSearchComponent)
    .component("htmlPreview", htmlPreviewComponent)
    .component("scenePreview", scenePreviewComponent)
    .component("liveViewPreview", liveViewPreviewComponent)
    .component("formsPreview", formPreviewComponent)
    .component("loader", loaderComponent)
    .component("startScreenArea", startScreenAreaComponent)
    .component("photoInput", photoInputComponent)
    .component("phoneMsg", phoneMsgComponent)
    .component("emailPreview", emailPreviewComponent)
    .component("htmlCustomBtnPreview", htmlCustomBtnPreviewComponent)
    .component("individualTextOutputPreview", individualTextOutputPreviewComponent)
    .component("individualTextScreenPreview", individualTextScreenPreviewComponent)
    .component("aiHtmlPreview",aiHtmlPreviewComponent);




// WEBPACK FOOTER //
// ./sources/components/components.js